import { render } from "./FeedbackContent.vue?vue&type=template&id=5b399d50&scoped=true"
import script from "./FeedbackContent.vue?vue&type=script&lang=js"
export * from "./FeedbackContent.vue?vue&type=script&lang=js"

import "./FeedbackContent.vue?vue&type=style&index=0&id=5b399d50&scoped=true&lang=css"

import exportComponent from "C:\\Users\\bfern\\Documents\\la-vuelta-trama\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b399d50"]])

export default __exports__